import { liveQuery } from "dexie";
import type { LiveQuery } from "@roqeet/core";

/**
 * Adapt Dexie's `liveQuery` to core's platform-neutral {@link LiveQuery}
 * contract (decision #13). The web UI subscribes via this so components
 * re-render when IndexedDB changes, with the query as the source of truth.
 */
export function toLiveQuery<T>(querier: () => Promise<T> | T): LiveQuery<T> {
  return {
    subscribe(onValue, onError) {
      const observable = liveQuery(querier);
      const sub = observable.subscribe({
        next: onValue,
        error: (e) => onError?.(e),
      });
      return () => sub.unsubscribe();
    },
  };
}
